import { useAuth } from '@dashai/contexts/AuthContext';
import { isDashmoteStaffEmail } from '../../../utils/isDashmoteStaffEmail';

interface AdminStatus {
  isAdmin: boolean;
  isSuperAdmin: boolean;
  loading: boolean;
}

/**
 * Hook to check if the current user is a Dashmote admin
 * Requires BOTH: @dashmote.com email AND the user-level dashmote_admin flag
 */
export function useAdminStatus(): AdminStatus {
  const { firestoreUser, loading } = useAuth();

  const isDashmoteEmail = isDashmoteStaffEmail(firestoreUser?.email);
  const isDemoAccount = firestoreUser?.email?.match(/^prod\..*\.demo@/) !== null;

  // The /admin gate is the user-level dashmote_admin flag, not a per-workspace
  // role. Email + demo guards stay so a stray flag can't grant a non-staff user.
  const isDashmoteAdmin =
    isDashmoteEmail && !isDemoAccount && firestoreUser?.dashmote_admin === true;

  const isAdmin = isDashmoteAdmin;

  return {
    isAdmin,
    isSuperAdmin: isDashmoteAdmin,
    loading
  };
}
